import {
  ComProtocolConnectOptions,
  ComProtocolDisconnectOptions,
  ConnectionState,
} from '@iotize/tap/protocol/api';
import { QueueComProtocol } from '@iotize/tap/protocol/core';
import { Observable, of, Subject } from 'rxjs';
import { delay, first } from 'rxjs/operators';

import { debug } from '../debug';
import { RouteType } from './definitions';
import { MockRouter } from './mock-router';

const TAG = 'MockProtocol';

export interface MockCallback {
  afterWrite(data: any): void;

  beforeWrite(message: any): void;

  afterRead(result: any): void;

  beforeRead(): void;
}

export interface RouteMapping {
  [key: string]: RouteType;
}

export function createMockProtocol() {
  return new MockProtocol();
}

export namespace MockProtocol {
  export interface Callback {
    afterRead(result: Observable<Uint8Array>): void;
    beforeRead(): void;
    afterWrite(request: Uint8Array): void;
    beforeWrite(request: Uint8Array): void;
  }
}
/**
 *
 * <p>
 * This is a mock com protocol for testing only
 * <p>
 * We can simulate iotize response according to the request message
 */
export class MockProtocol extends QueueComProtocol {
  _router: MockRouter;
  callback?: MockProtocol.Callback;
  mockOptions = {
    connect: {
      delay: 100,
    },
    disconnect: {
      delay: 100,
    },
    write: {
      delay: 1,
    },
  };

  input = new Subject<Uint8Array>();
  output = new Subject<Uint8Array>();

  private lastReceivedData?: Uint8Array;
  private lastTranseiveData?: Uint8Array;

  constructor() {
    super();
    this._router = new MockRouter();
    // this.connectDelay = 2000;
    // this.disconnectDelay = 2000;
    // this.callback = callback;
    // this.lastReceivedData = new Uint8Array(0);
    // this.configuration = new Configuration();
    // this.configuration.connectionTimeoutMillis = 3000;
    // this.configuration.sendTimeoutMillis = 3000;
  }

  public static MIRROR(): MockProtocol {
    const mockProtocol = new MockProtocol();
    mockProtocol.input.subscribe((input) => {
      mockProtocol.setOutputData(input);
    });
    // mockProtocol.router.addRoute(
    //     (command: Uint8Array) => {
    //         return true;
    //     },
    //     (request: Uint8Array) => {
    //         return request;
    //     }
    // );
    return mockProtocol;
  }

  // /**
  //  * Create a new instance from roote mapping
  //  */
  // public static createFromRoutes(map: RouteMapping): MockProtocol {
  //     const mockProtocol = new MockProtocol();
  //     mockProtocol.router.addRoutes(map);
  //     return mockProtocol;
  // }

  // public get router(): MockRouter {
  //     return this._router;
  // }

  setConnectionState(connectionState: ConnectionState) {
    debug(TAG, `setConnectionState: ${connectionState}`);
    this.connectionState = connectionState;
    return this;
  }

  public setConnectDelay(connectDelay: number) {
    this.mockOptions.connect.delay = connectDelay;
    return this;
  }

  public getDisconnectDelay() {
    return this.mockOptions.disconnect.delay;
  }

  public setDisconnectDelay(disconnectDelay: number) {
    this.mockOptions.disconnect.delay = disconnectDelay;
    return this;
  }

  public setOutputData(inputData: Uint8Array) {
    this.lastTranseiveData = inputData;
    this.output.next(inputData);
  }

  public setInputData(outputData: Uint8Array) {
    this.lastReceivedData = outputData;
    this.input.next(outputData);
  }

  public setCallback(callback: MockProtocol.Callback) {
    this.callback = callback;
  }

  _connect(options?: ComProtocolConnectOptions): Observable<any> {
    return of(undefined).pipe(delay(this.mockOptions.connect.delay));
  }

  _disconnect(options?: ComProtocolDisconnectOptions): Observable<any> {
    return of(undefined).pipe(delay(this.mockOptions.disconnect.delay));
  }

  public async write(request: Uint8Array): Promise<any> {
    try {
      if (this.callback) {
        await this.callback.beforeWrite(request);
      }

      // this.lastReceivedData = request;
      // const response = this.router.findRoute(request);
      // if (!response) {
      //     throw new Error(`Not route for request ${bufferToHexString(request)}`)
      // }
      // debug(
      //     TAG,
      //     'MockProtocol',
      //     'Mocking response for ' + request + ' => ' + response
      // );
      // var result = this.responseEncoder.encode(response);
      this.setInputData(request);

      if (this.callback) {
        await this.callback.afterWrite(request);
      }
      return new Promise((resolve) =>
        setTimeout(resolve, this.mockOptions.write.delay),
      );
    } catch (err) {
      return new Promise((resolve, reject) =>
        setTimeout(() => reject(err), this.mockOptions.write.delay),
      );
    }
  }

  public read(): Promise<Uint8Array> {
    try {
      if (this.callback) {
        this.callback.beforeRead();
      }
      return this.output
        .pipe(first())
        .toPromise()
        .then((v) => (v ? v : new Uint8Array()));
      // while (!this.hasNewData()) {
      //     // TODO wait ??
      // }
      // if (this.lastTranseiveData) {
      //     const result = of(this.lastTranseiveData);
      //     if (this.callback) {
      //         this.callback.afterRead(result);
      //     }
      //     return result.toPromise();
      // } else {
      //     return Promise.reject(new Error('Read timeout'));
      // }
    } catch (err) {
      return Promise.reject(err);
    }
  }
}

//    public addOnRequestListener() {
//        this.mOnRequestListener =
//    }

//    public interface onRequestListener{
//        onRequest(RequestMessage request);
//    }
